import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BuildingIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M18.2335 3.1001H5.76685V19.1001H4V20.9001H20V19.1001H18.2335V3.1001ZM16.4335 19.1001V4.9001H7.56685V19.1001H16.4335ZM9 6.66675H11V8.66675H9V6.66675ZM11 10.6667H9V12.6667H11V10.6667ZM9 14.6667H11V16.6667H9V14.6667ZM15 6.66675H13V8.66675H15V6.66675ZM13 10.6667H15V12.6667H13V10.6667ZM15 14.6667H13V16.6667H15V14.6667Z"
      />
    </SvgIcon>
  );
});
